// Month keys for the Sci Report: 'YYYY-MM' in UTC, matching the backend's
// utils/reportMonths.js so a key round-trips through ?month= unchanged.

const MONTH_KEY = /^\d{4}-(0[1-9]|1[0-2])$/;

export const isMonthKey = (s) => typeof s === 'string' && MONTH_KEY.test(s);

export const currentMonthKey = (date = new Date()) =>
  `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;

const parts = (key) => key.split('-').map(Number);

/** Key for the month `delta` months after `key` (negative steps back). */
export const shiftMonth = (key, delta) => {
  const [y, m] = parts(key);
  return currentMonthKey(new Date(Date.UTC(y, m - 1 + delta, 1)));
};

/** 'September 2026' */
export const monthLabel = (key) => {
  const [y, m] = parts(key);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleString('en-US', {
    month: 'long', year: 'numeric', timeZone: 'UTC',
  });
};

/** 'Sep 1 – Sep 30, 2026' */
export const monthSpanLabel = (key) => {
  const [y, m] = parts(key);
  const first = new Date(Date.UTC(y, m - 1, 1));
  const last = new Date(Date.UTC(y, m, 0));
  const opts = { month: 'short', day: 'numeric', timeZone: 'UTC' };
  return `${first.toLocaleString('en-US', opts)} – ${last.toLocaleString('en-US', opts)}, ${y}`;
};

/** Every key from `from` up to and including `to`, oldest first. */
export const monthsBetween = (from, to) => {
  const out = [];
  let k = from;
  while (k <= to) {
    out.push(k);
    k = shiftMonth(k, 1);
  }
  return out;
};

/** '10 / 01 / 2026' (the report's date style) from an ISO timestamp. */
export const fmtReportDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${String(d.getMonth() + 1).padStart(2, '0')} / ${String(d.getDate()).padStart(2, '0')} / ${d.getFullYear()}`;
};

/** 'Oct 1' from an ISO timestamp, for the compact per-row "last visit". */
export const fmtShortDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-US', { month: 'short', day: 'numeric' });
};
